<template>
  <layout>
    <page-header>
      <template slot="header">
        <h4>{{ $t('orders.edit_payment_order') }}</h4>
        <div v-if="order" class="inline-block ml-4 mt-1">
          <order-status :order="order" />
        </div>
      </template>
    </page-header>
    <div class="content">
      <resource-form
        v-if="currentDivision"
        ref="form"
        :id="$route.params.id"
        @saved="returnBack"
        @cancelled="returnBack"
        @loaded="formLoaded"
      />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'
import OrderStatus from './OrderStatus'

const resourceBase = 'orders'

export default {
  name: 'OrderEdit',

  components: {
    ResourceForm,
    OrderStatus,
  },

  data: () => ({
    order: null,
  }),

  methods: {
    formLoaded(result) {
      this.order = result.data
    },
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
